<template>
    <div :class="$style[classes]">
    <el-radio-group v-model="crrentValue" @change="change" class="wt-radio-input" :style="{display:[!isLine?'block':'']}">
      <el-radio :class="[!isLine?'radio-margin':'']" v-for="(item,index) in radios" :key="index" :label="item[radioValue]?item:item" :disabled="item.disabled">
    {{item.label}}
    <template v-if="item.is_slot">
      <slot :data="item" v-if="hasSlot"/>
      <template v-else>
    <wt-selector  class="radio-input-data" v-if="item.slot_type=='select'" :options="options" v-model="item[extraValue]" :disabled="item.extraDisabled"></wt-selector>
    <el-input  class="radio-input-data" v-else  v-model="item[extraValue]" size="small"
          :disabled="item.extraDisabled">
          <template v-if="item.input_slot_name" :slot="item.input_slot_name">
          <el-button v-if="item.input_slotButton" >
          </el-button>
          <template v-else>
              {{item.input_slot_icon}}</template>
          </template>
          </el-input>
    <span>{{item.unit}}</span>
      </template>
    </template>
  </el-radio>
    </el-radio-group>
    </div>
</template>
<script>
const prefixCls = 'wt-radio-slot'
export default {
  name: 'wt-radio-slot',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    radioValue: {
      type: String,
      default: 'value'
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    extraValue: {
      type: String,
      default: 'extra_value'
    },
    value: {
      type: [Object, String],
      default: ''
    },
    radios: {
      type: Array,
      default: function () {
        return []
      }
    },
    isLine: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      crrentValue: this.value,
      hasSlot:null
    }
  },
  watch: {
    value (val) {
      this.crrentValue = val
    },
    radios: {
      handler: function (val) {
        val.forEach(item => {
          if (item[this.radioValue] === this.crrentValue) {
            this.$emit('changed', item)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val)
      this.radios.forEach(item => {
        if (item.value === val) {
          this.$emit('changed', item)
        }
      })
    }
  },
  created(){
    this.hasSlot=this.$slots&&this.$slots.default
  }
}
</script>
<style module lang="less">
.wt-radio-slot{
  :global{
.wt-radio-input {
    display: flex;
    .el-radio-group{
      display: flex
    }
    .radio-margin{
        margin-bottom: 10px;
        margin-left: 0
    }
    .radio-input-data {
        display: inline-block;
        margin-left: 5px;
    }
    .el-radio{
        display: flex;
        align-items: center;
        .el-radio__input{
        }
        .el-radio__label{
            display: flex;
            align-items: center
        }
    }
    .wt-select,
    .wt-input {
        max-width: 150px;
    }
    .wt-input{
        display: inline-block;
        .el-input{
            display: inline-table
        }
    }
    .wt-select {
        .el-input__suffix-inner {
            height: 40px;
            width: 25px;
            // display: -webkit-box;
        }
        .el-icon-arrow-up {
            right: 5px;
        }
    }
}
  }
}
</style>
